<template>
  <v-toolbar app color="linear-gradient" dark>
    <v-toolbar-items>
      <v-btn flat to="/">
        <img class="logo" src="@/assets/cl_logo_white.svg" />
        <img class="logo_small" src="@/assets/cl_icon_white.svg" />
      </v-btn>
      <v-btn
        v-for="(value, key) in navLinks"
        v-if="value.show"
        :key="value.key"
        :to="`/spaces/${currentSpace.id}/${key}`"
        class="desktop-menu"
        flat
        >{{ value.label }}</v-btn
      >
      <v-btn
        v-if="isSuperAdmin && !isSuperAdminRoute"
        to="/admin"
        class="desktop-menu"
        flat
        >Super Admin
      </v-btn>
      <v-btn
        v-if="isSuperAdmin && isSuperAdminRoute"
        to="/spaces"
        class="desktop-menu"
        flat
        >Spaces
      </v-btn>
    </v-toolbar-items>
    <v-menu
      v-if="currentSpaceAvailable"
      class="mobile-menu"
      content-class="mobile-menu-content"
      offset-y
    >
      <v-toolbar-side-icon slot="activator" />
      <v-list v-if="currentSpaceAvailable">
        <v-list-tile
          v-for="(value, key) in navLinks"
          :key="value.key"
          :to="`/spaces/${currentSpace.id}/${key}`"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ value.label }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-spacer />

    <v-toolbar-items>
      <TheHeaderSpaceMenu
        v-if="currentSpaceAvailable"
        v-bind="{ currentSpace, spaces, selectSpace }"
      />
      <v-btn
        v-show="isAdmin"
        v-if="currentSpaceAvailable"
        :to="`/spaces/${currentSpace.id}/settings`"
        flat
        icon
      >
        <v-icon>settings</v-icon>
      </v-btn>
      <TheHeaderAvatar v-bind="{ currentUser, logout }" />
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import TheHeaderAvatar from "@/components/TheHeaderAvatar";
import TheHeaderSpaceMenu from "@/components/TheHeaderSpaceMenu";

export default {
  components: {
    TheHeaderAvatar,
    TheHeaderSpaceMenu,
  },
  props: {
    isSpaceRoute: {
      type: Boolean,
      required: true,
      default: false,
    },
    currentUser: {
      type: Object,
      required: true,
    },
    isSuperAdminRoute: {
      type: Boolean,
      required: true,
      default: false,
    },
    currentSpace: {
      type: Object,
      required: false,
      default: null,
    },
    isAdmin: {
      type: Boolean,
      required: true,
    },
    spaces: {
      type: Array,
      required: true,
    },
    selectSpace: {
      type: Function,
      required: true,
    },
    logout: {
      type: Function,
      required: true,
    },
    isSuperAdmin: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    navLinks() {
      return {
        campaigns: {
          label: "Campaigns",
          show: this.currentSpaceAvailable,
        },
        fields: {
          label: "Fields",
          show: this.currentSpaceAvailable && this.isAdmin,
        },
        set: {
          label: "Query Map",
          show: this.currentSpaceAvailable && this.isAdmin,
        },
      };
    },
    currentSpaceAvailable() {
      return this.isSpaceRoute && this.currentSpace;
    },
  },
};
</script>

<style lang="scss">
.linear-gradient {
  background: linear-gradient(to right, $theme-secondary, $theme-primary);
}
.logo {
  display: block;
  width: 200px;
}
.logo_small {
  display: none;
  height: 22px;
}
.desktop-menu {
  display: flex;
}
.mobile-menu {
  display: none;
}
.mobile-menu-content {
  margin-top: 10px;
}
@media (max-width: 800px) and (min-width: 755px) {
  .v-toolbar__items {
    .v-btn {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
@media (max-width: 754px) {
  .v-toolbar__items {
    .v-btn {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}
@media (max-width: 724px) {
  .logo {
    display: none;
  }
  .logo_small {
    display: block;
  }
}
@media (max-width: 604px) {
  .desktop-menu {
    display: none;
  }
  .mobile-menu {
    display: block;
  }
}
</style>
